import { filter, map } from 'rxjs/operators';
import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import { Observable } from 'rxjs';
import { BrandingState } from '../../branding/store/branding.state';
import { BrandingService } from '../../branding/providers/branding.service';
import { AccessibilityService } from '../../../providers/accessibility/accessibility.service';
import { TranslateService, TranslatePipe } from '@ngx-translate/core';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-terms',
    templateUrl: './terms.component.html',
    styleUrls: ['./terms.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [AsyncPipe, TranslatePipe]
})
export class TermsComponent implements OnInit {
    public brandingData$: Observable<BrandingState>;
    public bodyText$: Observable<string>;

    constructor(private brandingService: BrandingService,
                private accessibilityService: AccessibilityService,
                private translate: TranslateService) {
        this.brandingData$ =
            this.brandingService.getBrandingSettingsFromStore().pipe(filter(e => e !== null && e !== undefined));
        
        this.bodyText$ = this.brandingData$.pipe(
            map(brandingData => this.getBodyText(brandingData))
        );
    }

    ngOnInit(): void {
        // BFSG: Announce legal document loading to screen readers
        this.translate.get('ACCESSIBILITY.TERMS_LOADED').subscribe(message => {
            this.accessibilityService.announceToScreenReader(message, 'polite');
        });
    }

    getBodyText(brandingData: BrandingState): string {
        const terms = brandingData?.translationKeys?.legal?.terms;
        return terms?.body ?? 'LEGAL.TERMS-AND-CONDITIONS.BODY';
    }
}
